/* eslint-disable no-param-reassign,consistent-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message } from "antd";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { tenantsIdRoute, tenantsRoute } from "../../lib/routes/tenant";
import { tenantsData } from "../../components/TenantsAdmin/TenantsAdminInterfaces";
import { LoadingStatusCode } from "../../lib/types";

interface InitialState {
  tenants: any;
  tenantsLoading: LoadingStatusCode;
  tenant: any;
  tenantLoading: LoadingStatusCode;
}

const initialState: InitialState = {
  tenants: "",
  tenantsLoading: rtkRequestStatusCodes.idle,
  tenant: "",
  tenantLoading: rtkRequestStatusCodes.idle,
};

const createUpdateTenants = createAsyncThunk(
  "tenants-admin/createUpdateTenants",
  async (dataPost: tenantsData) => {
    try {
      message.loading("Сохранение", 0);
      const response = axios.patch(tenantsRoute(), dataPost);
      const { data } = await response;
      message.destroy();
      message.success("Тенант успешно обновлён");
      return data;
    } catch (e) {
      message.destroy();
      message.error("Ошибка обновления");
    }
  }
);

const fetchTenants = createAsyncThunk("tenants-admin/fetchTenants", async () => {
  const url = tenantsRoute();
  const response = axios.get(url);
  const { data } = await response;
  return data;
});

const fetchTenant = createAsyncThunk("tenants-admin/fetchTenant", async (id: number | null) => {
  const url = tenantsIdRoute(id);
  const response = axios.get(url);
  const { data } = await response;
  return data;
});

export const slice = createSlice({
  name: "tenantsAdmin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenants.fulfilled, (state, action) => {
        state.tenants = action.payload;
        state.tenantsLoading = rtkRequestStatusCodes.fulfilled;
      })
      .addCase(fetchTenants.pending, (state) => {
        state.tenantsLoading = rtkRequestStatusCodes.pending;
      })
      .addCase(fetchTenants.rejected, (state) => {
        state.tenantsLoading = rtkRequestStatusCodes.pending;
      })
      .addCase(fetchTenant.fulfilled, (state, action) => {
        state.tenant = action.payload;
        state.tenantLoading = rtkRequestStatusCodes.fulfilled;
      })
      .addCase(fetchTenant.pending, (state) => {
        state.tenantLoading = rtkRequestStatusCodes.pending;
      })
      .addCase(fetchTenant.rejected, (state) => {
        state.tenantLoading = rtkRequestStatusCodes.pending;
      });
  },
});

const { reducer } = slice;

export { fetchTenants, fetchTenant, createUpdateTenants };

export default reducer;
